import { StyleSheet } from 'react-native';
import { createStackNavigator } from '@react-navigation/stack';
import { useModalHeaderStyle } from 'src/presentation/hooks/useHeaderStyle';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';
import MessageDetailScreen from 'src/presentation/screens/MessageDetailScreen';
import MessagesScreen from 'src/presentation/screens/MessagesScreen';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import NavigationButton from 'src/presentation/components/molecules/NavigationButton';
import { SvgIconType } from '@thermenresorts/icons';
import type { MessagesNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import Fonts from 'src/core/utils/Fonts';
import { headerLayoutOptions, transparentHeaderBackground } from 'src/presentation/navigation/defaultScreenOptions';
import Constants from 'src/core/utils/Constants';
import Translations from 'src/core/utils/Translations';

const Stack = createStackNavigator<MessagesNavigation>();

const MessagesStackNavigator = () => {
	useActiveLanguage();

	const modalHeaderStyle = useModalHeaderStyle();
	const headerStyle = {
		...modalHeaderStyle,
		backgroundColor: Colors.transparent,
	};

	return (
		<Stack.Navigator
			screenOptions={{
				...headerLayoutOptions,
				cardStyle: { flex: Dimens.flex1 },
				headerShown: true,
				headerTransparent: false,
				headerTitleStyle: {
					fontFamily: Fonts.ptSerif,
					fontSize: Dimens.fontSize20,
					elevation: Dimens.elevation0,
				},
			}}
		>
			<Stack.Screen
				component={MessagesScreen}
				name={Constants.screenMessagesIndex}
				options={({ navigation }) => ({
					title: Translations.messages,
					headerTitleAlign: 'center',
					headerStyle,
					...transparentHeaderBackground,
					headerLeft: () => null,
					headerRight: () => (
						<NavigationButton
							accessibilityLabel={Translations.close}
							backgroundColor={Colors.white}
							icon={SvgIconType.cross}
							iconColor={Colors.gray800}
							iconSize={Dimens.iconSize12}
							pressedBackgroundColor={Colors.gray150}
							style={styles.headerButtonRight}
							onPress={() => navigation.goBack()}
						/>
					),
				})}
			/>
			<Stack.Screen
				component={MessageDetailScreen}
				name={Constants.screenMessageDetail}
				options={({ navigation }) => ({
					title: '',
					headerStyle,
					...transparentHeaderBackground,
					headerLeft: () => (
						<NavigationButton
							accessibilityLabel={Translations.goBack}
							backgroundColor={Colors.white}
							icon={SvgIconType.chevronLeft}
							iconColor={Colors.gray800}
							iconSize={Dimens.iconSize12}
							pressedBackgroundColor={Colors.gray150}
							style={styles.headerButtonLeft}
							onPress={() => navigation.goBack()}
						/>
					),
				})}
			/>
		</Stack.Navigator>
	);
};

const styles = StyleSheet.create({
	headerButtonLeft: {
		marginLeft: Dimens.padding18,
	},
	headerButtonRight: {
		marginRight: Dimens.padding18,
	},
});

export default MessagesStackNavigator;
